const educationData = [
    {
        title: "January 2017 - May 2019",
        cardTitle: "Keyano College",
        cardSubtitle: "Diploma - Business Administration- Management",
        cardDetailedText:
            "Studied Business Administration with a focus on Management.",
    },
    {
        title: "2013 - 2016",
        cardTitle: "H. L. College of Commerce",
        cardSubtitle: "Bachelor of Commerce - BCom, Business/Commerce, General",
        cardDetailedText:
            "Completed a Bachelor of Commerce degree with a focus on Business/Commerce.",
    },
    {
        title: "2011 - 2013",
        cardTitle: "Shree Ganesh Vidhya Mandir",
        cardSubtitle: "High School, Business/Commerce, General",
        cardDetailedText:
            "Completed high school with a focus on Business/Commerce.",
    },
];

const certificationData = [
    {
        title: "The Complete 2023 Web Development Bootcamp",
        cardTitle: "Verify Certificate ✅",
        cardSubtitle: "Udemy : Dr. Angela Yu Bootcamp",
        url: "https://udemy-certificate.s3.amazonaws.com/image/UC-b4eaa240-987b-48be-87c4-a183eeedd705.jpg?v=1692861854000",

        cardDetailedText: "",
        media: {
            name: "Udemy Certificatio : Web Development Bootcamp",
            source: {
                url: "https://udemy-certificate.s3.amazonaws.com/image/UC-b4eaa240-987b-48be-87c4-a183eeedd705.jpg?v=1692861854000",
            },
            type: "IMAGE",
        },
    },

    {
        title: "Complete Python Developer in 2023:Zero to Mastery",
        cardTitle: "Verify Certificate ✅",
        cardSubtitle: "Udemy : Andrei Neagoie",
        url: "https://udemy-certificate.s3.amazonaws.com/image/UC-90653b4c-a49d-40f2-80d2-b43b3e14c563.jpg?v=1680486807000",

        cardDetailedText: "",
        media: {
            name: "Udemy Certificatio : Web Development Bootcamp",
            source: {
                url: "https://udemy-certificate.s3.amazonaws.com/image/UC-90653b4c-a49d-40f2-80d2-b43b3e14c563.jpg?v=1680486807000",
            },
            type: "IMAGE",
        },
    },

    {
        title: "Python and SQL for Data Science",
        cardTitle: "Verify Certificate ✅",
        cardSubtitle: "Scaler Topics: Srikant Varma",
        url: "https://moonshot.scaler.com/s/sl/QQZTt-z4He",

        cardDetailedText: "",
        media: {
            name: "Udemy Certificatio : Web Development Bootcamp",
            source: {
                url: "https://moonshot.scaler.com/s/image/sl/QQZTt-z4He?scope=body",
            },
            type: "IMAGE",
        },
    },

    {
        title: "Python Core ",
        cardTitle: "Verify Certificate ✅",
        cardSubtitle: "Solo Learn",
        url: "https://www.sololearn.com/certificates/CT-UPWGZQYC",

        cardDetailedText: "",
        media: {
            name: "Solo Learn Certification",
            source: {
                url: "https://api2.sololearn.com/v2/certificates/CT-UPWGZQYC/image/jpg",
            },
            type: "IMAGE",
        },
    },
];

export { educationData, certificationData };
